/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeTransactionEncryptionEnvelope
 */
export interface RuntimeTransactionEncryptionEnvelope {
    /**
     * The format of the encrypted evm transaction envelope.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    format: string;
    /**
     * The base64-encoded public key used to encrypt the transaction.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    public_key?: string;
    /**
     * The base64-encoded nonce used to encrypt the transaction data.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    data_nonce?: string;
    /**
     * The base64-encoded encrypted transaction data.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    data?: string;
    /**
     * The base64-encoded nonce used to encrypt the transaction results.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    result_nonce?: string;
    /**
     * The base64-encoded encrypted result data.
     * @type {string}
     * @memberof RuntimeTransactionEncryptionEnvelope
     */
    result?: string;
}

export function RuntimeTransactionEncryptionEnvelopeFromJSON(json: any): RuntimeTransactionEncryptionEnvelope {
    return RuntimeTransactionEncryptionEnvelopeFromJSONTyped(json, false);
}

export function RuntimeTransactionEncryptionEnvelopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeTransactionEncryptionEnvelope {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'format': json['format'],
        'public_key': !exists(json, 'public_key') ? undefined : json['public_key'],
        'data_nonce': !exists(json, 'data_nonce') ? undefined : json['data_nonce'],
        'data': !exists(json, 'data') ? undefined : json['data'],
        'result_nonce': !exists(json, 'result_nonce') ? undefined : json['result_nonce'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function RuntimeTransactionEncryptionEnvelopeToJSON(value?: RuntimeTransactionEncryptionEnvelope | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'format': value.format,
        'public_key': value.public_key,
        'data_nonce': value.data_nonce,
        'data': value.data,
        'result_nonce': value.result_nonce,
        'result': value.result,
    };
}


